import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useState } from 'react';
import utils from '../../../../utils';
import s from './index.less';

export default function Imglist (props) {
    useStyles(s);
    const Viewer = typeof document !== 'undefined' && require('react-viewer').default;
    const [imgList, setImgList] = useState({
        list: props.imglist.length ? props.imglist : [{}],
        hasImg: !!props.imglist.length,
        selected: 0,
        barIndex: 0,
        bar: '0px',
        modalIsOpen: false,
        viewerImgList: [],
    });

    useEffect(() => {
        setImgList({
            ...imgList,
            viewerImgList: utils.imgWatermark(imgList.list, 'src')
        });
    }, []);

    const imgClickFun = (index) => {
        setImgList({
            ...imgList,
            selected: index,
            bar: `-${136 * index}px`
        });
    }

    const pre = () => {
        if (!imgList.hasImg || imgList.selected === 0) return;
        imgClickFun(--imgList.selected);
    }

    const next = () => {
        if (!imgList.hasImg || imgList.selected === imgList.list.length - 1) return;
        imgClickFun(++imgList.selected);
    }

    const toggleModal = () => {
        setImgList({
            ...imgList,
            modalIsOpen: !imgList.modalIsOpen
        });
    }

    const imgError = (e, type) => {
        e.target.onerror = null;
        e.target.src = require(`../../../../images/common/${type ? "detail-default-big.png" : "default-img.png"}`);
    }

    return (
        <>
            <div className={`page-detail-img ${props.isGoods ? 'goods'  : ''}`}>
                <div className={imgList.hasImg && imgList.list[imgList.selected].src ? 'img-container' : 'img-container nothing'}>
                    {imgList.selected === 0 && props.isVr.isVr === true ?
                        <a href={props.isVr.vrModelInfo.mid}>
                            <img onError={(e) => imgError(e, 'big')} src={imgList.hasImg ? (imgList.list[0].src ? `${imgList.list[0].src}?x-oss-process=style/acommon` : require("../../../../images/common/detail-default-big.png")) : require("../../../../images/common/detail-default-big.png")} />
                        </a>
                        : <img onError={(e) => imgError(e, 'big')} src={imgList.hasImg ?
                            (imgList.list[imgList.selected].src ? `${imgList.list[imgList.selected].src}?x-oss-process=style/acommon` : require("../../../../images/common/detail-default-big.png")) : require("../../../../images/common/detail-default-big.png")}
                            onClick={imgList.hasImg ? toggleModal : () => { }} />}

                    {imgList.hasImg ?
                        <>
                            {imgList.selected === 0 && props.isVr.isVr === true ?
                                <div className="VR-logo">
                                    <a href={props.isVr.vrModelInfo.mid}><img src="https://static.hsdcyf.com/hs/img/1725443792597.png" /></a>
                                </div> : null}
                            <span className="right">共{imgList.list.length}张</span>
                        </>
                        : null}
                </div>
                {imgList.hasImg ?
                    <div className="img-list">
                        <ul className="animation" style={{ left: imgList.bar }}>
                            {imgList.list.map((items, index) => {
                                return (<li key={index} className={imgList.hasImg && imgList.selected === index ? 'active' : ''}>
                                    <img onError={(e) => imgError(e)} className="animation" src={imgList.hasImg && items.src ? `${items.src}?x-oss-process=style/asmall` : require("../../../../images/common/detail-default.png")}
                                        onClick={() => imgList.hasImg ? imgClickFun(index) : null} />
                                    {imgList.hasImg && index === 0 && props.isVr.isVr === true ? <i>VR房源图</i> : (imgList.hasImg ? <i>{items.alt}</i> : null)}
                                </li>
                                )
                            })}
                        </ul>
                        <span className={!imgList.hasImg || imgList.selected === 0 ? "pre disabled" : "pre"} onClick={pre}><i className="iconfont icon-left">&#xe785;</i></span>
                        <span className={!imgList.hasImg || imgList.selected === imgList.list.length - 1 ? "next disabled" : "next"} onClick={next}><i className="iconfont icon-right">&#xe783;</i></span>
                    </div> : null}
            </div>
            {Viewer ? <Viewer
                className="react-img"
                visible={imgList.modalIsOpen}
                onClose={toggleModal}
                activeIndex={imgList.selected}
                images={imgList.viewerImgList}
                disableMouseZoom
                drag={false}
            /> : null}
        </>
    );
}